<template>
    <div>
        <el-form>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="课文标题：">
                        <el-input v-model="textName" style="width: 200px;" placeholder="请输入课文标题"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="课文分类：">
                        <el-cascader v-model="categoryId" placeholder="请选择课文分类" :options="courseCategory"
                            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }" clearable>
                        </el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="操作时间：">
                        <el-date-picker v-model="qTime" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-DD HH:mm:ss"
                            value-format="yyyy-MM-DD HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="flex jc-fe pl-30 pr-30">
                <el-button type="primary" @click="search()">
                    <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                </el-button>
                <el-button @click="search('refresh')">
                    <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                </el-button>
            </div>
        </el-form>
        <el-button type="primary" plain icon="el-icon-plus" @click="addText(1)">新增音视频课文</el-button>
        <el-button type="primary" plain icon="el-icon-plus" @click="addText(2)">新增图文课文</el-button>

        <dy-table :columns="columns" style="margin-top: 12px;" :table-data="textList" ref="fbTable"
            v-loading="tableLoading" :total="total" :page-num="pageNum" :page-size="10"
            @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
        <el-dialog :destroy-on-close="true" :close-on-click-modal="false" :title="dialogTitle"
            :visible.sync="addVisible" width="80%" :before-close="formClose">
            <el-form ref="textForm" v-if="addVisible" :model="textForm" :rules="textRules" label-width="60px">
                <el-form-item label="课文标题：" prop="textName" required>
                    <el-input style="width: 500px;" v-model="textForm.textName" placeholder="请输入课文标题"></el-input>
                </el-form-item>
                <el-form-item label="课文简介：">
                    <el-input style="width: 500px;" type="textarea" autosize v-model="textForm.describe"
                        placeholder="请输入课文简介"></el-input>
                </el-form-item>
                <el-form-item label="主讲人：">
                    <el-select v-model="textForm.lecturerList" placeholder="请选择主讲人" @change="$forceUpdate()" multiple>
                        <el-option v-for="item in lecturerList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="课文分类：">
                    <el-cascader placeholder="请选择课文分类" v-model="textForm.categoryId" :options="courseCategory"
                        :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }" clearable>
                    </el-cascader>
                </el-form-item>

                <el-form-item label="课文推荐标签：">
                    <el-select v-model="textForm.labelName" :multiple-limit="3" placeholder="请选择标签" multiple>
                        <el-option v-for="item in labelList" :key="item.labelId" :label="item.labelName"
                            :value="item.labelId"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="预估学习时长：" required>
                    <!-- <el-time-select v-model="textForm.learnTime" placeholder="请选择学习时长"
                        :picker-options="{ start: '00:15', step: '00:15', end: '03:00' }">
                    </el-time-select> -->
                    <el-input style="width: 120px;" v-model="textForm.hh" type="number" placeholder="请输入小时"
                        class="custom-input"></el-input>
                    :
                    <el-input style="width: 120px;" v-model="textForm.mm" type="number" placeholder="请输入分钟"
                        class="custom-input"></el-input>
                </el-form-item>

                <el-form-item label="留言开关：">
                    <el-radio v-model="textForm.isMessage" :label="1">开启</el-radio>
                    <el-radio v-model="textForm.isMessage" :label="0">不开启</el-radio>
                </el-form-item>

                <!-- <el-form-item label="留言开关：">
                    <el-radio v-model="textForm.isMessage" :label="1">开启</el-radio>
                    <el-radio v-model="textForm.isMessage" :label="0">不开启</el-radio>
                </el-form-item> -->
                <div v-if="textType == 2" style="margin-bottom: 12px;">正文内容:</div>
                <div v-if="textType == 2" style="border: 1px solid #ccc; margin-bottom: 15px;">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                        mode="simple" />
                    <Editor style="height: 300px; overflow-y: hidden;" v-model="richText" :defaultConfig="editorConfig"
                        mode="simple" @onCreated="onCreated" />
                </div>

                <!-- <el-form-item label="允许转载：">
                    <el-switch style="display: block" v-model="textForm.coursewareStatus" :active-value="1"
                        :inactive-value="0">
                    </el-switch>
                </el-form-item> -->

                <!-- 资源类型:0,视频 1课件,2教学设计,3学习任务 4课程总结, 5成果展示, 6拓展学习资料资源 -->
                <!-- 选择视频 -->
                <relativeResourceCommon v-if="textType == 1" :type="0" title="视频" :list="textForm.videoResource"
                    @saveData="setResource">
                </relativeResourceCommon>
                <!-- 选择课件 -->
                <relativeResourceCommon :type="1" title="课件" :list="textForm.coursewareResource"
                    @saveData="setResource">
                </relativeResourceCommon>
                <!-- 选择教学设计 -->
                <relativeResourceCommon :type="2" title="教学设计" :list="textForm.designResource" @saveData="setResource">
                </relativeResourceCommon>
                <!-- 选择学习任务单 -->
                <relativeResourceCommon :type="3" title="学习任务单" :list="textForm.taskResource" @saveData="setResource">
                </relativeResourceCommon>
                <!-- 选择课程总结/评价 -->
                <relativeResourceCommon :type="4" title="课程总结/评价" :list="textForm.summaryResource"
                    @saveData="setResource">
                </relativeResourceCommon>
                <!-- 选择成果展示 -->
                <relativeResourceCommon :type="5" title="成果展示" :list="textForm.achievementResource"
                    @saveData="setResource">
                </relativeResourceCommon>
                <!-- 选择成果展示 -->
                <relativeResourceCommon :type="6" title="拓展学习资料" :list="textForm.learnMaterialResource"
                    @saveData="setResource">
                </relativeResourceCommon>

                <!-- 相关课程 -->
                <relativeRecommendCommon :type="1" title="课程" @saveData="setRecommend" :list="textForm.courseRecommend">
                </relativeRecommendCommon>
                <!-- 相关文章 -->
                <relativeRecommendCommon :type="2" title="文章" @saveData="setRecommend"
                    :list="textForm.articleRecommend">
                </relativeRecommendCommon>

                <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                    <el-button type="primary" plain @click="submitForm()">保存</el-button>
                    <el-button type="danger" plain @click="() => addVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>

        <textMessage ref="textMessage"></textMessage>
    </div>
</template>
<script>

import host from '@/api/index';

import DyTable from '@/components/common/dytable'
import relativeResourceCommon from '@/components/common/relativeResourceCommon/index'
import relativeRecommendCommon from '../components/relativeRecommendCommon/index'
import { textPublish, textDelete } from '@/api/index';

import { getTextInfo, getTextList, listLecturer, saveText } from '@/api/index2';

import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, strToArr, arrToStr } from '@/utils/utils';

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

import textMessage from './textMessage'

export default {
    name: "studyText",
    components: {
        DyTable,
        relativeResourceCommon,
        relativeRecommendCommon,
        textMessage,
        Editor,
        Toolbar,
    },
    props: {
        labelList: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            courseCategory: [],
            lecturerList: [],

            searchForm: {},

            textName: null,
            categoryId: null,
            qTime: [],

            columns: [],
            textList: [],
            tableLoading: true,
            total: 0,
            pageNum: 1,
            pageSize: 10,

            dialogTitle: '新增课文',
            addVisible: false,

            textType: null,
            textForm: {
            },

            textRules: {
                textName: [
                    { required: true, message: '请输入课文名称', trigger: 'blur' },
                    { required: true, message: '请输入课文名称', trigger: 'change' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
            },
            editor: null,
            richText: '',
            toolbarConfig: {
                excludeKeys: ["insertImage", "insertVideo"],
            },
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    uploadImage: {
                        // 图片文件上传接口地址
                        server: host.uploadImgUrl,
                        timeout: 5 * 1000, // 5s
                        // fieldName 要与接口规定的Form Data文件字段名一致
                        fieldName: 'file',
                        headers: {
                            'bg-token': localStorage.getItem('token')
                        },
                        allowedFileTypes: ['image/png', 'image/jpeg'], // 允许的文件类型
                        maxFileSize: 10 * 1024 * 1024, // 10M
                        // 若接口返回的数据结构与官方规定的不一致, 则需要 customInsert 方法将返回的路径传给编辑器
                        customInsert(res, insertFn) {
                            const url = res.data.url
                            insertFn(url)
                        },
                        onSuccess: (file, res) => {
                            console.log('图片上传成功', file, res);
                        },
                        onError: (file, err) => {
                            console.error('图片上传失败', file, err);
                        },
                    },
                },
            },

        };
    },
    created() {
        this.columns = [
            {
                type: 'index',
                title: '序号'
            },

            {
                key: 'id',
                title: '课文ID'
            },
            {
                key: 'textName',
                title: '课文名称'
            },
            {
                key: 'categoryName',
                title: '课文分类'
            },
            {
                key: 'textType',
                title: '课文类型',
                render: ({ row }) => {
                    if (row.textType == 1) {
                        return (
                            <div>
                                音视频
                            </div>
                        );
                    } else if (row.textType == 2) {
                        return (
                            <div>
                                图文
                            </div>
                        );
                    } else {
                        return (
                            <div>
                                其他
                            </div>
                        );
                    }
                }
            },
            {
                key: 'bgUserName',
                title: '操作人'
            },
            {
                key: 'updateDate',
                title: '最后更新时间'
            },
            {
                key: '',
                title: '操作',
                width: 300,
                render: ({ row }) => {
                    if (row.publishStatus == 0) {
                        return (
                            <div>
                                <el-link type="primary" onClick={() => this.doEdit(row)}>编辑</el-link>
                                {/* <el-link type="warning" style="margin-left:12px" onClick={() => this.textPublish(row)}>上线</el-link> */}
                                <el-link type="primary" style="margin-left:12px" onClick={() => this.msgManage(row)}>留言管理</el-link>
                                <el-link type="danger" style="margin-left:12px" onClick={() => this.doDelete(row)}>删除</el-link>
                            </div>
                        );
                    } else if (row.publishStatus == 1) {
                        return (
                            <div>
                                {/* <el-link type="warning" style="margin-left:12px" onClick={() => this.textPublish(row)}>下线</el-link> */}
                                <el-link type="primary" style="margin-left:12px" onClick={() => this.msgManage(row)}>留言管理</el-link>
                            </div>
                        );
                    }
                }
            },
        ];
    },
    mounted() {
        this.getLecturer();
        this.getCourseCategory();
        this.getList();

    },

    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },

    methods: {

        getLecturer() {
            let info = {
                needPage: false,
            };
            listLecturer(info).then((res) => {
                console.log('listLecturer :>> ', res);
                if (res.result == 1) {
                    this.lecturerList = res.data;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },

        async getCourseCategory() {
            this.courseCategory = await this.$store.dispatch('category/getCourseCategory');
        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },

        // 编辑课文
        doEdit(t) {
            this.dialogTitle = '编辑课文';
            let param = {
                id: t.id
            }
            getTextInfo(param).then((res) => {
                console.log('res :>> ', res);
                this.textForm = res.data;
                this.textType = this.textForm.textType;
                this.richText = this.textForm.richText;

                let [hh, mm] = this.textForm.learnTime.split(":")
                this.textForm.hh = hh
                this.textForm.mm = mm

                this.textForm.labelName = this.labelList.filter(item =>
                    new Set(JSON.parse(this.textForm.labelName)).has(item.labelName)
                ).map(item =>
                    item.labelId
                );
                this.textForm.articleRecommend = this.textForm.articleList || [];
                for (let e of this.textForm.articleRecommend) {
                    e.recommendId = e.id;
                    e.recommendType = 2;
                    delete e['id']
                }

            });
            this.addVisible = true;
        },
        msgManage(row) {
            this.$refs.textMessage.msgDialogOpen(row);
        },
        setResource(param) {
            console.log('paprm :>> ', param);
            switch (param.type + 0) {
                // 0 视频
                case 0:
                    this.textForm.videoResource = param.data;
                    break;
                // 1 课件
                case 1:
                    this.textForm.coursewareResource = param.data;
                    break;
                // 2 教学设计
                case 2:
                    this.textForm.designResource = param.data;
                    break;
                // 3 学习任务
                case 3:
                    this.textForm.taskResource = param.data;
                    break;
                // 4 课程总结/评价资源
                case 4:
                    this.textForm.summaryResource = param.data;
                    break;
                // 5 成果展示资源
                case 5:
                    this.textForm.achievementResource = param.data;
                    break;
                // 6 拓展学习资料资源
                case 6:
                    this.textForm.learnMaterialResource = param.data;
                    break;
                default:
                    break;
            }
        },
        setRecommend(param) {
            console.log('paprm :>> ', param);
            switch (param.type + 0) {
                // 1 相关课程
                case 1:
                    this.textForm.courseRecommend = param.data;
                    break;
                // 2 相关文章
                case 2:
                    this.textForm.articleRecommend = param.data;
                    break;
                default:
                    break;
            }
        },
        // 新增
        addText(type) {
            this.textType = type;
            this.textForm = {};
            this.richText = "";
            this.addVisible = true;
        },

        formClose(done) {
            this.textForm = {};
            this.$refs.textForm.resetFields();
            done(); // 确认关闭
        },
        // 分页
        onCurrentChange(val) {
            this.pageNum = val;
            this.getList();
        },
        // 删除
        doDelete(row) {
            this.$confirm(`确认要删除此课文吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    id: row.id,
                    isDelete: row.isDelete == 1 ? 0 : 1
                };
                var data = encrypt(JSON.stringify(info));
                textDelete(data).then((res) => {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList();
                });
            })
        },

        // 上线/下线
        textPublish(row) {
            let msg = "";
            if (row.publishStatus == 1) {
                msg = "下线后，课程中该课文将不显示，是否下线？"
            } else {
                msg = "确认要上线此课文吗?"
            }

            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    id: row.id,
                    publishStatus: row.publishStatus == 1 ? 2 : 1
                };
                var data = encrypt(JSON.stringify(info));
                textPublish(data).then((res) => {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList();
                });
            })
        },
        // 提交表单
        submitForm() {
            this.$refs.textForm.validate((valid) => {
                if (valid) {
                    if ((!this.textForm.hh && !this.textForm.mm) || this.textForm.mm > 59) {
                        this.$message({
                            message: '请正确填写预估学习时长',
                            type: 'warning'
                        });
                        return
                    }
                    if (this.textType == 1 && (!this.textForm.videoResource || this.textForm.videoResource.length == 0)) {
                        this.$message({
                            message: '请选择视频',
                            type: 'warning'
                        });
                        return
                    } else if (this.textType == 2 && this.richText == '<p><br></p>') {
                        this.$message({
                            message: '请正填写富文本',
                            type: 'warning'
                        });
                        return
                    } else if (this.textForm.videoResource.length > 1) {
                        this.$message({
                            message: '目前仅支持选择一个视频，请删除其他视频',
                            type: 'warning'
                        });
                        return
                    } else if (this.textForm.courseRecommend && this.textForm.courseRecommend.length > 3) {
                        this.$message({
                            message: '最多可以选择三个相关课程推荐，请删除多余课程',
                            type: 'warning'
                        });
                        return
                    } else if (this.textForm.articleRecommend && this.textForm.articleRecommend.length > 3) {
                        this.$message({
                            message: '最多可以选择三个相关文章推荐，请删除多余文章',
                            type: 'warning'
                        });
                        return
                    } else if (this.textForm.liveRecommend && this.textForm.liveRecommend.length > 3) {
                        this.$message({
                            message: '最多可以选择三个相关直播推荐，请删除多余直播',
                            type: 'warning'
                        });
                        return
                    }


                    this.textForm.learnTime = `${this.textForm.hh || '00'}:${this.textForm.mm || '00'}`
                    var info = JSON.parse(JSON.stringify(this.textForm));
                    let labelName = this.labelList.filter(item =>
                        new Set(info.labelName).has(item.labelId)
                    ).map(item =>
                        item.labelName
                    )
                    info.labelName = JSON.stringify(labelName);
                    info.textType = this.textType;

                    info.richText = this.richText;

                    saveText(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            this.addVisible = false;
                            this.pageNum = 1;
                            this.getList();
                            this.$message({
                                showClose: true,
                                message: '保存成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });

                } else {
                    this.$message({
                        message: '请正确填写表单信息',
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        //数字转文字
        numberToText(arr, str) {
            let res = '';
            if (str) {
                let sArr = str.split(",");
                sArr.forEach(element => {
                    res += arr[element - 1].label + ' ';
                });
            }
            return res;
        },


        search(msg) {
            this.pageNum = 1;

            this.searchForm = {
                textName: this.textName,
                categoryId: this.categoryId,
                startTime: this.qTime[0],
                endTime: this.qTime[1],
            }
            if (msg == "refresh") {
                this.textName = null;
                this.categoryId = null;
                this.qTime = [];
                this.searchForm = {};
            }
            this.getList()
        },
        getList() {
            this.tableLoading = true;
            let param = {
                page: this.pageNum,
                pageSize: this.pageSize,
                ...this.searchForm,
            };
            getTextList(param).then((res) => {
                if (res.result == 1) {
                    this.total = res.data.total;
                    this.pageNum = res.data.pageNum;
                    this.textList = res.data.list;
                    this.tableLoading = false;

                    this.textList.forEach(e => {
                        if (e.publishStatus == 2) {
                            e.publishStatus = 0
                        }
                    })

                    console.log('textList :>> ', this.textList);

                } else {
                    console.log('error11');
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        }
    }
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>



/* 隐藏右侧增减按钮 */
.custom-input input::-webkit-outer-spin-button,
.custom-input input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.custom-input input[type='number'] {
    -moz-appearance: textfield;
}
</style>